// @flow

import dompurify from 'dompurify';
import { rem } from 'polished';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
import { Col } from 'react-awesome-styled-grid';
import { useSelector } from 'react-redux';
import styled, { type StyledComponent } from 'styled-components';

import winamaxLogoImage from '../../../assets/images/w-logo.svg';
import { type RootState } from '../../../store/types';
import { media } from '../../../styles/GlobalStyle';
import { checkGoBack } from '../../../utils/CommonUtils';

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
import { ButtonBack } from './ButtonBack';

type LeftSideRawProps = {
  className?: string,
  title: string,
  noButtonBack?: boolean,
};

const LeftSideRaw = ({ className, title, noButtonBack = false }: LeftSideRawProps) => {
  const sanitizer = dompurify.sanitize;
  const common = useSelector((state: RootState) => state.common);
  const idHasBeenScanned = common && common.identityScan && !!Object.keys(common.identityScan).length;
  const shouldDisplayGoBack = checkGoBack(common.step, common.subStep, idHasBeenScanned);

  return (
    <Col
      className={`${String(className)} column left-side`}
      xs={12}
      md={5}
      offset={{ xs: 0, md: 1 }}
    >
      <div className={'left-side-content'}>
        {/* Logo */}
        <div className={'left-side-logo'}>
          <img
            src={winamaxLogoImage}
            alt={'Winamax'}
          />
        </div>

        {/* Back button */}
        {shouldDisplayGoBack && !noButtonBack && (
          <div className={'left-side-button'}>
            <ButtonBack />
          </div>
        )}

        {/* Title */}
        <h1 dangerouslySetInnerHTML={{ __html: sanitizer(title) }} />
      </div>
    </Col>
  );
};

export const LeftSide: StyledComponent<LeftSideRawProps, {}, typeof LeftSideRaw> = styled(
  LeftSideRaw,
)`
  display: none;

  ${media.greaterThan('desktop')`
    display: block;
  `}

  .left-side-content {
    top: 50px;
    left: 0;
    &.sticky {
      position: sticky;
    }
  }

  .left-side-logo {
    z-index: 3;
    position: relative;
    padding-bottom: 20px;
  }

  h1 {
    font-size: ${rem('60px')};
    line-height: ${rem('66px')};
    padding-top: 20px;
    font-weight: 900;
    z-index: 3;
    position: relative;
    user-select: none;
  }
`;
